if (!customElements.get('rocket-testimonials-component')) {
  class RocketTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      this.playVideo();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      this.initSlider();
    }

    initSlider() {
      const sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: 7,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        breakpoints: {
          768: {
            spaceBetween: 12,
          }
        },
        pagination: false,
        threshold: 2,
        simulateTouch: true,
        grabCursor: true,
        draggable: true,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }
    playVideo() {
      const testimonialsItems = this.querySelectorAll(".testimonials__items .f-column");
      testimonialsItems.forEach((testimonialsItem) => {
        const playBtn = testimonialsItem.querySelector(".play-video-btn");
        const muteBtn = testimonialsItem.querySelector(".mute-video-btn");
        const videoElm = testimonialsItem.querySelector("video");
        if (playBtn) {
          playBtn?.addEventListener("click", () => {
            videoElm.play();
            playBtn.classList.add("hidden");
          });
          if (videoElm) {
            videoElm.addEventListener("click", () => {
              if (videoElm.paused) {
                videoElm.play();
                playBtn.classList.add("hidden");
              } else {
                videoElm.pause();
                playBtn.classList.remove("hidden");
              }
            });
          }
        }
        if (muteBtn) {
          muteBtn.addEventListener("click", () => {
            console.log(videoElm.muted);
            
            videoElm.muted = !videoElm.muted;
            muteBtn.classList.toggle("active", !videoElm.muted); 
          });
        }
      })
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('rocket-testimonials-component', RocketTestimonials);
}
